import { Flex } from "@chakra-ui/react";
import { PriceCard, PriceCardProps } from "./price-card";

export interface PricingOptionsProps {
  title: string;
  price: string | number;
}

export interface PricingPlanProps {
  content: PriceCardProps[];
  pricingOptions: PricingOptionsProps[];
}

export const PricingPlan = ({ content, pricingOptions }: PricingPlanProps) => {
  return (
    <Flex
      borderRadius={6}
      flexDirection={{
        base: "column",
        md: "row",
      }}
      pb={16}
      pt={3}
      gap={{
        base: 4,
        md: 1,
      }}
    >
      {content.map((plan, idx) => (
        <PriceCard
          key={`pricing-card-${idx}`}
          pricingOptions={pricingOptions}
          title={plan.title}
          featureList={plan.featureList}
          button={plan.button}
          mobileSubtitle={plan.mobileSubtitle}
          desktopSubtitle={plan.desktopSubtitle}
          planImage={plan.planImage}
          plan={plan.plan}
        />
      ))}
    </Flex>
  );
};
